import {MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {Component, OnInit, Inject, ViewChild, ViewContainerRef, AfterViewInit} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Component({
  selector: 'standardDialog',
  templateUrl:  './standardDialog.components.html',
  styleUrls: ['./standardDialog.components.css']
})
export class StandardDialogComponent implements OnInit, AfterViewInit {
  @ViewChild('container', { read: ViewContainerRef }) dynamicComponent: ViewContainerRef;
  public title: string;
  public content: any;
  public daten: any;
  public componentInstanz

  constructor(
    public dialogRef: MatDialogRef<StandardDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
  ) {
    // Update view with given values
    this.title = data.title;
    this.content = data.content;
    this.daten  = data.data
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    if (typeof this.content !== 'string'){
      this.componentInstanz = this.dynamicComponent.createComponent(this.data.content)
    } else {
      ;this.dynamicComponent.element.nativeElement.parentElement.innerHTML = this.data.content
    }
  }
}
